export default {
  getData({ nip }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/external-data/get-by-nip/${ nip }`);
  },
};
